module.exports = __webpack_public_path__ + "assets/images/7-32YtDnJ.jpg";